import { Button, Heading, Spinner, Text } from '@radix-ui/themes';
import type { ReactNode } from 'react';
import { useAuth } from './AuthProvider.tsx';
import { LoginPage } from './LoginPage.tsx';
import { NoAccessPage } from './NoAccessPage.tsx';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { status, retry } = useAuth();

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center" role="status">
        <Spinner size="3" />
        <span className="sr-only">Loading</span>
      </div>
    );
  }

  if (status === 'anonymous') return <LoginPage />;

  if (status === 'forbidden') return <NoAccessPage />;

  if (status === 'error') {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-3 p-6 text-center">
        <Heading size="5">Cannot reach the server</Heading>
        <Text color="gray" size="2">
          We could not check your session. Check your connection and try again.
        </Text>
        <Button onClick={retry}>Try again</Button>
      </div>
    );
  }

  return <>{children}</>;
}
